import { JDNativeSystem } from '@jdreact/jdreact-core-lib';
import { Platform } from 'react-native';

let isIPhoneX = false;

if (Platform.OS === 'web') {
    isIPhoneX = (/iphone/gi.test(navigator.userAgent) && screen && screen.height / screen.width > 1.95);
} else {
    isIPhoneX = JDNativeSystem.isIPhoneX;
}

export default isIPhoneX;
